import { createContext } from "react";
let articleContext=createContext()

export default articleContext;